const bpStatusDK = {
    da: {
        New: "Ny",
        Reservation: "Reservation",
        Pending: "Afventer",
        Completed: "Gennemført",
        Cancel: "Annulleret",
        Rejected: "Afvist",
    },
};

/**
 * @ngdoc filter
 * @name abookApp.filter:translate
 * @description
 * # translate
 *
 * Usage
 * {{ string | translate}}
 * {{ string | translate:"lang" }}
 */

export default function bpStatusTranslate() {
    return function (input, lang) {
        return bpStatusDK[lang][input];
    };
}
